const warningLeadTimeMs = 15 * 1000;

function initialiseSessionExpiryWarning() {
    const modal = document.getElementById('session-expiry-modal');
    if (!modal) return;

    const renewalButton = document.getElementById('renew-session-button');
    const countdown = document.getElementById('session-expiry-countdown');
    const antiForgeryToken = document.querySelector('#session-renewal-form input[name="__RequestVerificationToken"]')?.value;
    let expiresAt = Date.parse(modal.dataset.sessionExpiresAt);
    let warningTimer;
    let expiryTimer;
    let countdownTimer;

    const redirectToExpiredSession = () => window.location.replace('/session-expired');
    const clearTimers = () => {
        window.clearTimeout(warningTimer);
        window.clearTimeout(expiryTimer);
        window.clearInterval(countdownTimer);
    };

    // Show the remaining time as mm:ss, rounding up so 00:00 appears only at expiry.
    const updateCountdown = () => {
        const secondsRemaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
        const minutes = Math.floor(secondsRemaining / 60);
        const seconds = secondsRemaining % 60;
        countdown.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const getCurrentSessionExpiry = async () => {
        const response = await fetch('/session/status', { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok || response.redirected) {
            redirectToExpiredSession();
            return null;
        }

        return Date.parse((await response.json()).expiresAt);
    };

    const scheduleTimers = () => {
        clearTimers();
        const timeRemaining = expiresAt - Date.now();
        if (timeRemaining <= 0) {
            redirectToExpiredSession();
            return;
        }

        warningTimer = window.setTimeout(showWarningIfStillNeeded, Math.max(0, timeRemaining - warningLeadTimeMs));
        expiryTimer = window.setTimeout(redirectToExpiredSession, timeRemaining);
    };

    const showWarningIfStillNeeded = async () => {
        const currentExpiry = await getCurrentSessionExpiry();
        if (!currentExpiry) return;

        expiresAt = currentExpiry;
        if (expiresAt - Date.now() > warningLeadTimeMs) {
            scheduleTimers();
            return;
        }

        if (expiresAt <= Date.now()) {
            redirectToExpiredSession();
            return;
        }

        $(modal).modal({ backdrop: 'static', keyboard: false });
        updateCountdown();
        countdownTimer = window.setInterval(updateCountdown, 1000);
    };

    renewalButton.addEventListener('click', async () => {
        renewalButton.disabled = true;
        try {
            const response = await fetch('/session/renew', {
                method: 'POST',
                headers: { Accept: 'application/json', RequestVerificationToken: antiForgeryToken }
            });

            if (!response.ok || response.redirected) {
                redirectToExpiredSession();
                return;
            }

            expiresAt = Date.parse((await response.json()).expiresAt);
            $(modal).modal('hide');
            scheduleTimers();
        } catch {
            redirectToExpiredSession();
        } finally {
            renewalButton.disabled = false;
        }
    });

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) return;
        if (Date.now() >= expiresAt) redirectToExpiredSession();
        else updateCountdown();
    });

    if (Number.isNaN(expiresAt)) {
        getCurrentSessionExpiry()
            .then(currentExpiry => {
                if (!currentExpiry) return;
                expiresAt = currentExpiry;
                scheduleTimers();
            })
            .catch(redirectToExpiredSession);
        return;
    }

    scheduleTimers();
}

document.addEventListener('DOMContentLoaded', initialiseSessionExpiryWarning);
